<template>
	<div class="tpl mine-wrap">
		<div class="not-login-wrap" v-if="!uid">
			<div class="login-top">
				<div class="user-intro-box">
					<div class="user-intro">
						<div class="user-img">
							<div class="user-avatar">
								<img src="../../assets/img/mine/upload-img-default.png"/>
							</div>
							<span class="vip-icon">
								<img src="../../assets/img/mine/center_ic_head_pressed1.png"/>
							</span>
						</div>
						<div class="user-info">
							<p class="user-name">未登录<img src="../../assets/img/common/ic_user_vip@2x.png" alt="" /></p>
							<p class="user-id">ID:000000</p>
						</div>
					</div>
					<div class="go-login">
						登录后查看主页<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />
					</div>
				</div>
			</div>
			<div class="no-content">
				<img src="../../assets/img/default/bg_img_login@2x.png"/>
				<p>你还没有登陆呢，登录后才能查看哦~</p>
				<router-link tag="button" :to="{name:'login'}">立即登录</router-link>
			</div>
		</div>
		<div class="has-login-wrap" v-if="uid">
			<div class="login-top">
				<div class="user-intro-box">
					<div class="user-intro">
						<div class="user-img">
							<div class="user-avatar">
								<img :src="personInfo.avatar"/>
							</div>
							<span class="vip-icon">
								<img src="../../assets/img/mine/center_ic_head_pressed1.png"/>
								<span class="level">{{personInfo.grade}}</span>
							</span>
						</div>
						<div class="user-info">
							<p class="user-name">{{personInfo.nickname}}<img v-if="personInfo.is_vip==1" src="../../assets/img/common/ic_user_vip@2x.png" alt="" /></p>
							<p class="user-id">ID:{{personInfo.uid}}</p>
						</div>
					</div>
					<div class="go-login" @click="toPersonalPage">
						个人主页<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />
					</div>
				</div>
			</div>
			<div class="personal-bag">
				<div @click="goToIntegral">
					<p class="value">{{personInfo.integral_sum}}</p>
					<p class="name">我的积分</p>
				</div>
				<div @click="goToWallet">
					<p class="value">{{personInfo.amount}}</p>
					<p class="name">我的钱包</p>
				</div>
			</div>
			<div class="personal-options">
				<ul>
					<router-link tag="li" :to="{name:'my-certification'}">
						<div class="name">
							<img src="../../assets/img/mine/center_ic_list_1.png"/>信用认证
						</div>
						<div class="value">
							{{personInfo.Authentication_sum}}个未认证<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />							
						</div>
					</router-link>
					<router-link tag="li" :to="{name:'my-question'}">
						<div class="name">
							<img src="../../assets/img/mine/center_ic_list_2.png"/>我的想问
						</div>
						<div class="value">
							去设置<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />							
						</div>
					</router-link>
					<router-link tag="li" :to="{name:'my-like'}">
						<div class="name">
							<img src="../../assets/img/mine/center_ic_list_3.png"/>喜欢
						</div>
						<div class="value">
							<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />							
						</div>
					</router-link>
					<router-link tag="li" :to="{name:'my-visitor'}">
						<div class="name">
							<img src="../../assets/img/mine/center_ic_list_4.png"/>访客记录
						</div>
						<div class="value">
							<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />							
						</div>
					</router-link>
					<router-link tag="li" :to="{name:'my-gifts'}">
						<div class="name">
							<img src="../../assets/img/mine/center_ic_list_5.png"/>我的礼物
						</div>
						<div class="value">
							<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />							
						</div>
					</router-link>
					<router-link tag="li" :to="{name:'vip-center'}">
						<div class="name">
							<img src="../../assets/img/mine/center_ic_list_6.png"/>会员中心
						</div>
						<div class="value">
							<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />							
						</div>
					</router-link>
					<router-link tag="li" :to="{name:'my-setting'}">
						<div class="name">
							<img src="../../assets/img/mine/center_ic_list_7.png"/>设置
						</div>
						<div class="value">
							<img src="../../assets/img/common/ic_arrow_enter@2x.png" alt="" />							
						</div>
					</router-link>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"mine",
		data(){
			return{
				uid:"",
				personInfo:"",
			}
		},
		created(){
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed", "mine");
			this.$store.commit("changeTabBarShow", true);
			this.getInfoList();
			
		},
		methods:{
			getInfoList(){
				this.$axios({
					url:"My/PersonalList",
					method:"post",
					data:{
						uid:this.uid
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.personInfo = res.data.data
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			goToIntegral(){
				this.$router.push({
					name:"my-integral"
				})
			},
			goToWallet(){
				this.$router.push({
					name:"my-wallet"
				})
			},
			toPersonalPage(){
				this.$router.push({
					name:"my-page-mine"
				})
			}
		}
	}
</script>

<style scoped>
	.mine-wrap{
		background: #f3f3f3;
	}
	.login-top{
		padding-top: 3rem;
		background: url(../../assets/img/mine/center_img_xxx_pressed.png) no-repeat 100%;
		filter: grayscale(1);
	}
	.has-login-wrap .login-top{
		filter: grayscale(0);
	}
	.user-intro-box{
		background: rgba(255,255,255,.5);
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 1rem;
	}
	.user-intro{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.user-intro .user-img{
		position: relative;
	}
	.user-intro .user-avatar{
		border-radius: 50%;
		overflow: hidden;
		border: 2px solid #fff;
		width: 4rem;
		height: 4rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.user-intro .user-avatar img{
		width: 4rem;
		display: block;
	}
	.user-intro .user-img .vip-icon{
	    position: absolute;
	    width: 1.5rem;
	    right: -0.2rem;
	    top: -0.8rem;
	}
	.user-intro .user-img .vip-icon img{
		width: 2rem;
	}
	.user-intro .user-img .vip-icon .level{
	    font-size: 0.7rem;
	    color: #fff;
	    top: 0.9rem;
	    left: 0.5rem;
	    position: absolute;
	    transform: rotate(45deg);
	}
	.user-intro .user-info{
		margin-left: 1.5rem;
	}
	.user-intro .user-name{
		font-size: 1rem;
		line-height: 1.5rem;
		color: #282828;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.user-intro .user-name img{
		width: 1.5rem;
	}
	.user-intro .user-id{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.user-intro-box .go-login{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.user-intro-box .go-login img{
		width: 2rem;
	}
	
	.personal-bag{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 1rem;
		background: #fff;
		margin: 0.3rem 0 0.5rem;
	}
	.personal-bag div{
		flex: 1;
		text-align: center;
		padding: 0.5rem 0;
	}
	.personal-bag div:active{
		background: #fafafa;
	}
	.personal-bag div:first-of-type{
		border-right: 1px solid #ccc;
	}
	.personal-bag .value{
		color: #5415F9;
		line-height: 1.5rem;
	}
	.personal-bag .name{
		color: #282828;
		line-height: 1.5rem;
	}
	.personal-options li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		border-bottom: 1px solid #f3f3f3;
		padding: 0.5rem 1rem;
	}
	.personal-options li:last-of-type{
		margin-top: 1rem;
	}
	.personal-options li div{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.personal-options li .name{
		font-size: 1rem;
		color: #282828;
	}
	.personal-options li .name img{
		width: 1.2rem;
		margin-right: 0.3rem;
	}
	.personal-options li .value{
		font-size: 0.8rem;
		color: #7b7b7b;
	}
	.personal-options li .value img{
		width: 2rem;
		margin-left: 0.3rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Mine/Mine.vue